import React, { useEffect, useState } from 'react'
import { sanitizeHtml } from '@/core/utils/sanitize'

interface ICheckboxFieldProps {
  checked?: boolean
  name?: string
  onChange: React.Dispatch<boolean>
  className?: string
  size?: 'normal' | 'large'
  label?: string
  disabled?: boolean
  toggle?: boolean
}

export default function CheckboxField({
  checked,
  onChange,
  className,
  size = 'large',
  label,
  disabled,
  toggle = true
}: ICheckboxFieldProps) {
  const [checkedDefault, setCheckedDefault] = useState<boolean | undefined>(
    checked
  )

  const toggleChecked = () => {
    if (!toggle && checkedDefault) return;
    onChange(!checkedDefault)
    setCheckedDefault(!checkedDefault)
  }

  useEffect(() => {
    setCheckedDefault(checked)
  }, [checked])

  return (
    <div
      className={`checkbox-field ${className ? className : ''} ${size} ${
        checkedDefault ? 'checked' : ''
      }`}
      style={{ opacity: disabled ? 0.3 : 1 }}
      onClick={() => !disabled && toggleChecked()}
    >
      <input
        type="checkbox"
        checked={checkedDefault}
        onChange={toggleChecked}
        disabled={disabled}
      />
      {label && <div className="checkbox-field__label" dangerouslySetInnerHTML={{ __html: sanitizeHtml(label) }} />}
    </div>
  )
}
